import React from 'react'
import { motion } from 'framer-motion'
import Skills from '../components/Skills'
import './SkillsPage.css'

const SkillsPage = () => {
  return (
    <div className="skills-page">
      <div className="container">
        <motion.div
          className="page-header"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="page-title">My Skills</h1>
          <p className="page-description">
            A comprehensive overview of my technical expertise and the tools I use to bring ideas to life.
          </p>
        </motion.div>
        <Skills />
      </div>
    </div>
  )
}

export default SkillsPage
